/* eslint-env browser */

/**
 * Wishlist button placement (PLP version)
 */
function handleWishlistAttribute(tile) {
  const wishlistBtn = tile.querySelector('.product-tile__wishlist--link');
  if (!wishlistBtn) return;

  if (!wishlistBtn.classList.contains('active')) {
    wishlistBtn.dataset.cnstrcBtn = 'add_to_wishlist';
  } else {
    delete wishlistBtn.dataset.cnstrcBtn;
  }
}

/**
 * Add to Cart button placement (PLP version)
 */
function handleAddToCartAttribute(tile) {
  if (!tile) return;

  const selectors = '.product-tile__action, .add-to-cart';
  const buttons = tile.querySelectorAll(selectors);

  buttons.forEach((btn) => {
    const isDirectAdd = btn.classList.contains('js-direct-add');
    const isRequiresSize = btn.classList.contains('js-requires-size');

    if (isDirectAdd) {
      btn.dataset.cnstrcBtn = 'add_to_cart';
      const variationId = btn.getAttribute('data-pid');

      if (variationId) {
        tile.dataset.cnstrcItemVariationId = variationId;
      }
    } else if (isRequiresSize) {
      const hasSelection = !!tile.querySelector('.sizelist .Selected');
      if (hasSelection) {
        btn.dataset.cnstrcBtn = 'add_to_cart';
      } else {
        delete btn.dataset.cnstrcBtn;
      }
    }
  });
}

function syncBtnAttrs(tile) {
  if (!tile) return;

  handleWishlistAttribute(tile);
  handleAddToCartAttribute(tile);
}

/**
 * EXPORTED: Handles size selection within a product tile overlay.
 * @param {Element} tile - The product tile element
 */
function bindPLPSizeSelection(tile) {
  if (!tile) return;
  const sizeInputs = tile.querySelectorAll('.product-tile__add-overlay-size-input');
  if (!sizeInputs || sizeInputs.length === 0) return;

  sizeInputs.forEach((input) => {
    input.addEventListener('change', (e) => {
      const sizesGrid = e.target.closest('.product-tile__add-overlay-sizes');
      if (!sizesGrid) return;
      if (e.target.checked) {
        const allWrappers = sizesGrid.querySelectorAll('.product-tile__add-overlay-size-wrapper');
        allWrappers.forEach((wrapper) => {
          const oldCartBtn = wrapper.querySelector('.add-to-cart');
          const oldWishlistBtn = wrapper.querySelector('.add-to-wish-list');
          if (oldCartBtn) delete oldCartBtn.dataset.cnstrcBtn;
          if (oldWishlistBtn) delete oldWishlistBtn.dataset.cnstrcBtn;
        });

        const buttonWrapper = e.target.closest('div.product-tile__add-overlay-size-wrapper');
        if (!buttonWrapper) return;

        setTimeout(() => {
          const cartBtn = buttonWrapper.querySelector('.add-to-cart');
          const variationId = cartBtn ? cartBtn.getAttribute('data-pid') : null;

          if (variationId) {
            tile.dataset.cnstrcItemVariationId = variationId;
            if (cartBtn) cartBtn.dataset.cnstrcBtn = 'add_to_cart';

            const sizeBtnContainer = buttonWrapper.querySelector('.product-tile__add-overlay-size-btn');
            const wishlistBtn = sizeBtnContainer ? sizeBtnContainer.querySelector('.add-to-wish-list') : null;

            if (wishlistBtn) {
              wishlistBtn.dataset.cnstrcBtn = 'add_to_wishlist';
              const tileWishlist = tile.querySelector('.product-tile__wishlist--link');
              if (tileWishlist) {
                delete tileWishlist.dataset.cnstrcBtn;
              }
            }
          }
        }, 150);
      }
    });
  });
}

module.exports = {
  syncBtnAttrs,
  bindPLPSizeSelection,
};
